module.exports = __webpack_public_path__ + "img/mq.9bcc4ffb.svg";